import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f60f790"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("HOME")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.path !== '/')
      ? (_openBlock(), _createBlock(_component_el_breadcrumb, {
          key: 0,
          separator: "|"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            (_ctx.showRouteName)
              ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$route.name), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbList, (name) => {
              return (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: name }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}